import { useQuery } from '@apollo/client';

import { usePatient } from 'hooks/usePatient/usePatient';
import { isOnlineBookingUnavailableForAppointmentType } from 'kb-shared/booking/utils/onlineBookingAvailability';
import { PATIENT_LAB_FACING } from 'kb-shared/graphql/queries';
import { AppointmentType } from 'kb-shared/types';
import { BugTracker } from 'kb-shared/utilities/bugTracker';

import { shouldHideInClinicNpvSlots } from './hideInClinicNpvSlots';

type PatientLabFacingResponse = {
  patient?: { id?: string; lab?: { id?: string; patientFacing?: boolean } };
};

export const useHideInClinicNpvSlots = (appointmentType?: AppointmentType | null) => {
  const { patient, isLoggedIn } = usePatient();
  const newPatientVisit = Boolean(
    appointmentType?.newPatientVisit ||
    appointmentType?.inClinicOrVirtualEquivalent?.newPatientVisit
  );
  const marketStatusRequired = Boolean(isLoggedIn) && newPatientVisit;
  const {
    data,
    loading: loadingMarketStatus,
    error: marketStatusError
  } = useQuery<PatientLabFacingResponse>(PATIENT_LAB_FACING, {
    skip: !marketStatusRequired,
    onError: error => BugTracker.notify(error, 'PatientLabFacingQuery')
  });

  const pending = marketStatusRequired && loadingMarketStatus;
  const hideInClinicSlots = shouldHideInClinicNpvSlots({
    patientFacing: data?.patient?.lab?.patientFacing ?? patient?.lab?.patientFacing,
    marketStatusFailed: Boolean(marketStatusError),
    onlineBookingUnavailable: isOnlineBookingUnavailableForAppointmentType({ appointmentType }),
    newPatientVisit
  });

  return { hideInClinicSlots, pending };
};
